import { Group, Tooltip, type TooltipProps } from "@mantine/core";
import {
  IconInfoCircle,
  type IconProps,
  type TablerIcon
} from "@tabler/icons-react";
import classNames from "classnames";
import ReactMarkdown from "react-markdown";
import { THEME_VARS } from "../../utils/constants";
import { MarkdownLink } from "../ReactMarkdown/MarkdownLink";
import "./IconHelpText.scss";

interface IconHelpTextProps extends Pick<IconProps, "aria-label"> {
  children?: React.ReactNode;
  className?: string;
  disableMarkdown?: boolean; // mk: this only exists to avoid tooltip being rendered locally in Icon
  helpText: string;
  Icon: TablerIcon;
  iconColor?: string;
  position?: TooltipProps["position"];
  size?: IconProps["size"];
  /** Wraps the text onto multiple lines beyond this width */
  maxWidth?: TooltipProps["maw"];
}

function IconHelpTextToolTip({
  "aria-label": ariaLabel,
  children,
  className,
  helpText,
  Icon,
  iconColor,
  disableMarkdown,
  position = "left",
  maxWidth,
  size
}: IconHelpTextProps) {
  const isInfo = Icon === IconInfoCircle;
  const icon = (
    <Icon
      aria-label={ariaLabel}
      className={classNames(className, "help-icon-clickable")}
      color={
        iconColor ?? (isInfo ? THEME_VARS.primary[6] : THEME_VARS.neutral[8])
      }
      role="img"
      size={size}
    />
  );

  return (
    <Tooltip
      className="icon-help-text-tooltip"
      label={
        disableMarkdown ? (
          helpText
        ) : (
          <ReactMarkdown
            components={{
              a: MarkdownLink
            }}
          >
            {helpText}
          </ReactMarkdown>
        )
      }
      maw={maxWidth}
      multiline={maxWidth !== undefined}
      position={position}
    >
      {children ? (
        <Group align="center" gap="xs" tabIndex={0} wrap="nowrap">
          {icon}
          {children}
        </Group>
      ) : (
        icon
      )}
    </Tooltip>
  );
}

export { IconHelpTextToolTip };
